import type { TestimonialBlock as TestimonialBlockProps } from '@/payload-types'
import React from 'react'
import { PreviewPerson } from '@/components'
import { isPerson, cn } from '@/lib/utils'

type Props = {
  className?: string
} & TestimonialBlockProps

export function TestimonialBlock({ className, quote, author }: Props): React.ReactNode {
  return (
    <blockquote className={cn('relative border-b bg-accent', className)}>
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col gap-2 items-center justify-center min-h-56 p-4">
        <div className="text-2xl font-light">{quote}</div>
        {author && isPerson(author) ? <PreviewPerson person={author} /> : null}
      </div>
    </blockquote>
  )
}
